import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'MoneyDisplay',
  props: {
    formattedValue: null,
    bgColor: { default: "#e8f5e8" },
    textColor: { default: "#179717" },
    addOnText: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})